import type { ApiResponse } from '../../../../../config/api-types'
import type { GetCollectionOrderStatusRequest } from '../../../domain/models/get-collection-order-status'
import * as types from '../types/get-collection-order-status-types'

export const getCollectionOrderStatusRequest = (
  payload: GetCollectionOrderStatusRequest,
) => ({
  type: types.GET_COLLECTION_ORDER_STATUS_REQUEST,
  payload,
})

export const getCollectionOrderStatusError = (payload: string) => ({
  type: types.GET_COLLECTION_ORDER_STATUS_ERROR,
  payload,
})

export const getCollectionOrderStatusSuccess = (payload: ApiResponse) => ({
  type: types.GET_COLLECTION_ORDER_STATUS_SUCCESS,
  payload,
})

export const getCollectionOrderStatusReset = () => ({
  type: types.GET_COLLECTION_ORDER_STATUS_RESET,
})